export default "__VITE_ASSET__B6m886$A__"